import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type InitialiseInviteSurveyInput = {
  invitePublicId: Scalars['String']['input'];
};

export type InitialiseInviteSurveyResponse = {
  __typename?: 'InitialiseInviteSurveyResponse';
  responseId: Scalars['String']['output'];
  survey: Survey;
};

export type Mutation = {
  __typename?: 'Mutation';
  initialiseInviteSurvey?: Maybe<InitialiseInviteSurveyResponse>;
};


export type MutationInitialiseInviteSurveyArgs = {
  input: InitialiseInviteSurveyInput;
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
};

export type Survey = {
  __typename?: 'Survey';
  code?: Maybe<Scalars['String']['output']>;
  definition?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type InitialiseInviteSurveyMutationVariables = Exact<{
  input: InitialiseInviteSurveyInput;
}>;


export type InitialiseInviteSurveyMutation = { __typename?: 'Mutation', initialiseInviteSurvey?: { __typename?: 'InitialiseInviteSurveyResponse', responseId: string, survey: { __typename?: 'Survey', code?: string | null, name?: string | null, definition?: string | null, version?: string | null } } | null };


export const InitialiseInviteSurveyDocument = gql`
    mutation InitialiseInviteSurvey($input: InitialiseInviteSurveyInput!) {
  initialiseInviteSurvey(input: $input) {
    survey {
      code
      name
      definition
      version
    }
    responseId
  }
}
    `;

export function useInitialiseInviteSurveyMutation() {
  return Urql.useMutation<InitialiseInviteSurveyMutation, InitialiseInviteSurveyMutationVariables>(InitialiseInviteSurveyDocument);
};